import React, { Component } from 'react';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import { isValidNameWithSpace, renderTextField, renderAutoCompleteSingleSelect } from './../../../components/reduxFields';

class GraphPlotline extends Component {
  
  constructor(props) {
    super(props);        
    this.state = {            
        BaselineLabel : props.BaselineLabel || [],        
        xAxisDateOption : props.xAxisDateOption, 
        dashStyleName : "ShortDash",
        dashStyle: [
          { id: 1, value: "Solid" },
          { id: 2, value: "ShortDash" },
          { id: 3, value: "ShortDot" },
          { id: 4, value: "Dot" },          
          { id: 5, value: "Dash" },       
          { id: 6, value: "LongDash" },          
          ]
      };  
  }

  dataBaselineSubmit = (event) => {

    if(Number(event.XPosition) >= 0 && event.labelText)
    {
      // console.log('event.id.........',event)
      let BaselineState = this.state.BaselineLabel;     
      let label = {
                    id: 'plotLine_' + Math.random(),
                    value: Number(event.XPosition),
                    color: '#000000',
                    width: 2,
                    dashStyle: this.state.dashStyleName,                   
                    label: {
                        text: event.labelText
                    },
                    events: {
                      dblclick: function(e) {
                            this.axis.removePlotLine(this.id)
                        }
                    }
                };
     
      BaselineState.push(label);
      this.props.dispatch(reset('GraphPlotlineForm'));
      // console.log('BaselineLabel..........',BaselineLabel)
      this.props.setBaselineState(BaselineState);
    }
}

dashStyleHandler = (input, selected) => {
  input.onChange(selected.value)
  this.setState({ [input.name]: selected.label });
}

handleChange = (input, selectedRecord) => {
  input.onChange(selectedRecord.value);
}

  renderBaselines() {   
      
      const { handleSubmit } = this.props;
        return (
            <div>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.dataBaselineSubmit)}>
                            <div className='row'>  
                                {/* <div className="col-sm-12">
                                    <Field
                                        name="XPosition"
                                        type="text"
                                        maxLength="2"
                                        label="X Position"                                        
                                        normalize={isInteger}
                                        component={renderTextField}
                                    />
                                </div> */}
                                <div className="col-sm-12 mt-35">
                                  <Field name="XPosition"
                                    label="X Position"
                                    handleNewRequest={this.handleChange}
                                    options={this.props.xAxisDateOption}
                                    component={renderAutoCompleteSingleSelect}
                                  />
                                </div>
                                <div className="col-sm-12">
                                    <Field
                                        name="labelText"
                                        type="text"
                                        maxLength="100"
                                        label="Label Text"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>    
                                <div className="col-sm-12 mt-30">
                                <Field
                                        name='dashStyleName'
                                        label="Dash Style"
                                        options={this.state.dashStyle}
                                        handleNewRequest={(input, selected) => this.dashStyleHandler(input, selected)}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>                                
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 btn_rt claims_filter mt-20">
                                <RaisedButton type="Submit" primary={true}>Add</RaisedButton>
                                {/* <RaisedButton className="grey_btn ml_15"  onTouchTap={this.handleClose}>Close</RaisedButton> */}
                            </div>
                        </form>
                    </div>                    
                </div>
            </div>
        )
  }

  render() {
    
    return (
      <div className='row'>
        <div className="col-12 col-sm-12 col-md-12 btn_lft reset-btn claims_filter mt-20">
          <IconMenu className="bell-icon"
            iconButtonElement={             
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Add Phase Change Line</RaisedButton>                        
            }
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}            
          >
            {this.renderBaselines()}
            
          </IconMenu>
        </div>
      </div>
    );
  }
}
GraphPlotline = reduxForm({
  form: 'GraphPlotlineForm',
  enableReinitialize: true,
})(GraphPlotline);

// function mapStateToProps(state, ownProps) {
//   console.log('ownProps............',ownProps)
//   return {
//     //notifications: state.notifications,
//   };
// }

export default connect(null)(GraphPlotline);



// WEBPACK FOOTER //
// ./src/modules/patients/containers/graphPlotline.js